import * as yup from "yup";

const ForgetPageValidation = yup.object().shape({
	email: yup
		.string()
		.email("Lütfen geçerli bir e-posta adresi giriniz.")
		.required("E-posta adresi boş bırakılamaz."),
});

export default ForgetPageValidation;
